import React, {useEffect, useState} from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {LoadingComponent} from 'recupero-comunes'
import { Card, Container } from 'react-bootstrap'
import BuscarCasosReserva from './buscar-casos-reserva'
import BandejaCasosReserva from './bande-casos-reserva'
import { configuracionFormAction32} from '../../store/actions/are-busqueda-casos-action'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'

const BusquedaCasosReserva = () => {
    const [loading, setLoading]=useState(false)
    const [myQueryState, setMyQuery]=useState(null)
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves} = data_encargado
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :30
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    const dispatch = useDispatch()
    
    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosReducer)
    const {cfg_form32} = data_areaBuscar
    
    useEffect(()=>{        
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado,idOrgCaso:idOrganizacionCaso}))
    },[dispatch])

    useEffect(() => {
        if(llaves){ 
        setLoading(true)
         let query = Buffer.from(JSON.stringify({
             rutcia: llaves && llaves['idOrgCaso'],
             idform: 32
         })).toString('base64')
         dispatch(configuracionFormAction32(query))    
          .then(()=>setLoading(false))
        }
     }, [dispatch,llaves])

    return (
        <div> 
             <LoadingComponent show={loading}/>
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{
                                         cfg_form32 &&  `${cfg_form32.cfg_form32['consultacasos-filtrobusqueda']}
                                        `}</Card.Header>
                <Card.Body>
                        <BuscarCasosReserva setMyQuery={setMyQuery} />
                        <BandejaCasosReserva myQueryState={myQueryState} />
                  
             </Card.Body>
            </Card>
            </Container> 
        </div>
    )
}

export default BusquedaCasosReserva
